export default __webpack_public_path__ + "static/media/om.cf72330b.svg";